import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["source", "preview", "placeholder"];

  preview() {
    const file = this.sourceTarget.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.previewTarget.src = e.target.result;
        this.previewTarget.hidden = false;
        if (this.hasPlaceholderTarget) {
          this.placeholderTarget.hidden = true;
        }
      };
      reader.readAsDataURL(file);
    } else {
      this.previewTarget.hidden = true;
      if (this.hasPlaceholderTarget) {
        this.placeholderTarget.hidden = false;
      }
    }
  }

  trigger() {
    this.sourceTarget.click();
  }
}
